import React from 'react';
import PropTypes from 'prop-types';

import bgLogIn from '../../../../assets/images/bgLogIn.png';
import LogIcon from '../../../../assets/images/logIn.png';
import SalyIcon from '../../../../assets/images/saly.png';
import { Container, Wrapper, BoxlogIn, ImageBG, LeftImage } from './styled';

export const WrapPage = ({ children, iconRight }) => {
  return (
    <>
      <ImageBG src={bgLogIn} alt="" />
      <Container>
        <Wrapper>
          <BoxlogIn>{children}</BoxlogIn>
          <LeftImage>
            {iconRight ? <img src={SalyIcon} alt="SalyIcon" data-testid="LeftImage" /> : <img src={LogIcon} alt="login" data-testid="LeftImage" />}
          </LeftImage>
        </Wrapper>
      </Container>
    </>
  );
};

WrapPage.propTypes = {
  children: PropTypes.node,
  iconRight: PropTypes.any
};
